import { DestructureSupportDocs } from '../datasets/datasets.middleware';

const updatedBlueprintsSupportDocs = (data: BlueprintsResultAction) => {
    const { response } = data;
    let newResponse: UpdatedBlueprintResponse[] = [];
    if (response && (response as any).length > 0) {
        newResponse = (response as unknown as NewAPIBlueprints[]).map((item: NewAPIBlueprints) => {
            const { FormOrder = '', MarketPlaceSupportDocument = '', websiteurl = '', ...rest } = item;
            if (item.FormOrder && item.MarketPlaceSupportDocument && item.websiteurl) {
                return {
                    ...rest,
                    MarketplaceBlueprintSupportDocs: DestructureSupportDocs({
                        FormOrder: item.FormOrder || '',
                        MarketPlaceSupportDocument: item.MarketPlaceSupportDocument || '',
                        websiteurl: item.websiteurl || ''
                    })
                };
            }
            return { ...rest, MarketplaceBlueprintSupportDocs: [] };
        });
    }
    return { ...data, response: newResponse };
};

export default updatedBlueprintsSupportDocs;
